import { UserUpdateInput, useUserUpdateMutation } from 'shared/graphql';

import { useCurrentUser } from './useCurrentUser';

/**
 * @deprecated Use `useUserUpdateMutation` instead.
 */
export function useUserUpdate({ id }: { id?: string | null | undefined }) {
  const { userId: currentUserId } = useCurrentUser();

  const [userUpdate, { loading }] = useUserUpdateMutation({
    refetchQueries: ['CurrentUser', 'UserPublicProfile'],
    awaitRefetchQueries: true,
  });

  const onUserUpdate = async (data: UserUpdateInput) => {
    if (!id && !currentUserId) {
      return;
    }

    await userUpdate({ variables: { data: { ...data, id: id || currentUserId } } });
  };

  return { onUserUpdate, loading };
}
